export const CARS = "cars";
export const MOTORBIKES = "motorcycles";
